// // src/pages/admin/coupons/AdminCuppon.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { API } from "../../../config/api";
// import { get, del, put } from "../../../lib/http";

// const cn = (...a) => a.filter(Boolean).join(" ");
// const INR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

// export default function AdminCuppon() {
//   const navigate = useNavigate();

//   // data
//   const [coupons, setCoupons] = useState([]);
//   const [fetching, setFetching] = useState(true);
//   const [busyId, setBusyId] = useState(null);
//   const [error, setError] = useState("");

//   // filters
//   const [q, setQ] = useState("");
//   const [status, setStatus] = useState("all");      // all | active | inactive
//   const [type, setType] = useState("all");          // percentage | flat | all
//   const [sort, setSort] = useState("latest");       // latest | oldest | az | za | valueHigh | valueLow

//   // confirm modal
//   const [confirm, setConfirm] = useState({ open: false, id: null, name: "", nextActive: false, mode: "toggle" }); // mode: toggle|delete

//   /* ---------------- fetch ---------------- */
//   const fetchCoupons = async () => {
//     setFetching(true);
//     setError("");
//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const res = await get(API.coupon.getDiscount, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });

//       const list = Array.isArray(res)
//         ? res
//         : Array.isArray(res?.discounts)
//         ? res.discounts
//         : Array.isArray(res?.data?.discounts)
//         ? res.data.discounts
//         : [];

//       setCoupons(list);
//     } catch (err) {
//       console.error("getAllCoupon error:", err);
//       setCoupons([]);
//       setError("Failed to load coupons.");
//     } finally {
//       setFetching(false);
//     }
//   };

//   useEffect(() => {
//     fetchCoupons();
//   }, []);

//   /* --------------- helpers --------------- */
//   const fmtDate = (iso) => {
//     if (!iso) return "—";
//     const d = new Date(iso);
//     if (isNaN(d)) return "—";
//     return d.toLocaleString(undefined, { day: "2-digit", month: "short", year: "numeric" });
//   };

//   const discountLabel = (c) =>
//     String(c?.discountType).toLowerCase() === "percentage"
//       ? `${Number(c?.value ?? 0)}% off`
//       : `${INR(c?.value ?? 0)} off`;

//   const typeOptions = useMemo(() => {
//     // infer from data
//     const s = new Set();
//     coupons.forEach((c) => c?.discountType && s.add(String(c.discountType).toLowerCase()));
//     return ["all", ...Array.from(s).sort()];
//   }, [coupons]);

//   /* --------------- derived view --------------- */
//   const view = useMemo(() => {
//     let list = [...coupons];

//     // search
//     const term = q.trim().toLowerCase();
//     if (term) {
//       list = list.filter((c) =>
//         [c?.code, c?.description, c?.discountType]
//           .filter(Boolean)
//           .some((v) => String(v).toLowerCase().includes(term))
//       );
//     }

//     // status
//     if (status !== "all") {
//       const want = status === "active";
//       list = list.filter((c) => Boolean(c?.isActive) === want);
//     }

//     // type
//     if (type !== "all") {
//       list = list.filter((c) => String(c?.discountType).toLowerCase() === type);
//     }

//     // sort
//     list.sort((a, b) => {
//       const aName = (a?.code || "").toLowerCase();
//       const bName = (b?.code || "").toLowerCase();
//       const aDate = new Date(a?.updatedAt || a?.createdAt || 0).getTime();
//       const bDate = new Date(b?.updatedAt || b?.createdAt || 0).getTime();
//       const aVal = Number(a?.value || 0);
//       const bVal = Number(b?.value || 0);
//       switch (sort) {
//         case "latest": return bDate - aDate;
//         case "oldest": return aDate - bDate;
//         case "az": return aName.localeCompare(bName);
//         case "za": return bName.localeCompare(aName);
//         case "valueHigh": return bVal - aVal;
//         case "valueLow": return aVal - bVal;
//         default: return 0;
//       }
//     });

//     return list;
//   }, [coupons, q, status, type, sort]);

//   const isEmpty = !fetching && view.length === 0;

//   /* --------------- actions --------------- */
//   const onNew = () => navigate("/admin/coupon/new");
//   const onEdit = (c) => navigate(`/admin/coupon/edit/${c._id}`);

//   const askDelete = (c) =>
//     setConfirm({ open: true, id: c._id, name: c.code, nextActive: !!c.isActive, mode: "delete" });

//   const askToggle = (c) =>
//     setConfirm({ open: true, id: c._id, name: c.code, nextActive: !c.isActive, mode: "toggle" });

//   const doDelete = async () => {
//     if (!confirm.id) return;
//     try {
//       setBusyId(confirm.id);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       await del(`${API.coupon.delete}/${confirm.id}`, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "application/json",
//         },
//       });
//       setCoupons((prev) => prev.filter((x) => x._id !== confirm.id));
//     } catch (err) {
//       console.error("Delete error:", err);
//       alert("❌ Failed to delete coupon.");
//     } finally {
//       setBusyId(null);
//       setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" });
//     }
//   };

//   const doToggle = async () => {
//     if (!confirm.id) return;
//     try {
//       setBusyId(confirm.id);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const updated = await put(
//         `${API.coupon.update}/${confirm.id}`,
//         { isActive: confirm.nextActive },
//         {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const updatedId = updated?._id ?? confirm.id;
//       const updatedIsActive =
//         typeof updated?.isActive === "boolean" ? updated.isActive : confirm.nextActive;

//       setCoupons((prev) =>
//         prev.map((c) => (c._id === updatedId ? { ...c, isActive: updatedIsActive } : c))
//       );
//     } catch (err) {
//       console.error("Toggle error:", err);
//       alert("❌ Failed to update status.");
//     } finally {
//       setBusyId(null);
//       setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" });
//     }
//   };

//   /* --------------- UI --------------- */
//   return (
//     <div className="p-6 space-y-6">
//       {/* Title bar */}
//       <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
//         <div>
//           <h2 className="text-2xl font-extrabold text-slate-900 dark:text-white">Discount Coupons</h2>
//           <p className="text-sm text-slate-600 dark:text-slate-400">Create, edit & manage promo codes</p>
//         </div>
//         <div className="flex items-center gap-2">
//           <button
//             onClick={fetchCoupons}
//             className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-amber-900/20"
//           >
//             Refresh
//           </button>
//           <button
//             onClick={onNew}
//             className="rounded-full bg-gradient-to-r from-amber-400 to-amber-500 px-5 py-2 text-sm font-semibold text-slate-900 hover:from-amber-500 hover:to-amber-600 shadow"
//           >
//             + New Coupon
//           </button>
//         </div>
//       </div>

//       {/* Non-blocking error */}
//       {error && (
//         <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
//           {error}
//         </div>
//       )}

//       {/* Toolbar */}
//       <div className="sticky top-2 z-10 rounded-2xl bg-white/80 dark:bg-gray-900/60 backdrop-blur border border-amber-100/70 dark:border-gray-800 shadow-sm p-4">
//         <div className="grid gap-3 md:grid-cols-5">
//           {/* search */}
//           <div className="md:col-span-2">
//             <div className="relative">
//               <input
//                 value={q}
//                 onChange={(e) => setQ(e.target.value)}
//                 placeholder="Search by code or description…"
//                 className="w-full rounded-xl border px-4 py-2.5 pl-9 bg-white dark:bg-gray-950 dark:border-gray-800 text-sm"
//               />
//               <svg
//                 className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
//                 width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
//               >
//                 <circle cx="11" cy="11" r="8" /><path d="M21 21l-3.5-3.5" />
//               </svg>
//             </div>
//           </div>

//           {/* type */}
//           <Select
//             label="Type"
//             value={type}
//             onChange={setType}
//             options={typeOptions.map((t) => ({ label: t === "all" ? "All" : t, value: t }))}
//           />

//           {/* status */}
//           <Select
//             label="Status"
//             value={status}
//             onChange={setStatus}
//             options={[
//               { label: "All", value: "all" },
//               { label: "Active", value: "active" },
//               { label: "Inactive", value: "inactive" },
//             ]}
//           />

//           {/* sort */}
//           <Select
//             label="Sort"
//             value={sort}
//             onChange={setSort}
//             options={[
//               { label: "Latest", value: "latest" },
//               { label: "Oldest", value: "oldest" },
//               { label: "A → Z", value: "az" },
//               { label: "Z → A", value: "za" },
//               { label: "Value (High)", value: "valueHigh" },
//               { label: "Value (Low)", value: "valueLow" },
//             ]}
//           />
//         </div>
//       </div>

//       {/* Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
//         {/* skeletons */}
//         {fetching &&
//           Array.from({ length: 6 }).map((_, i) => (
//             <div key={`sk-${i}`} className="rounded-2xl border bg-white dark:bg-gray-900 dark:border-gray-800 p-4 animate-pulse">
//               <div className="h-40 w-full rounded-xl bg-slate-200 dark:bg-gray-800" />
//               <div className="mt-4 h-4 w-1/3 rounded bg-slate-200 dark:bg-gray-800" />
//               <div className="mt-2 h-3 w-2/3 rounded bg-slate-200 dark:bg-gray-800" />
//               <div className="mt-4 h-8 w-28 rounded-full bg-slate-200 dark:bg-gray-800" />
//             </div>
//           ))}

//         {!fetching &&
//           view.map((c) => {
//             const img = c.imageUrl || "https://picsum.photos/seed/coupon/800/400";
//             const validity = `${fmtDate(c.validFrom)} → ${fmtDate(c.validTo)}`;
//             const appliesTo =
//               Array.isArray(c.applicableEvents) && c.applicableEvents.length > 0
//                 ? `Selected events (${c.applicableEvents.length})`
//                 : "All events";
//             const usage =
//               c.usageLimit && c.usageLimit > 0
//                 ? `${c.usedCount ?? 0}/${c.usageLimit}`
//                 : `${c.usedCount ?? 0}/∞`;
//             const isBusy = busyId === c._id;

//             return (
//               <div
//                 key={c._id}
//                 className="group bg-white dark:bg-gray-900 rounded-2xl border dark:border-gray-800 shadow-sm hover:shadow-md transition overflow-hidden flex flex-col"
//               >
//                 {/* header image */}
//                 <div className="relative">
//                   <div className="aspect-[16/9] w-full bg-slate-100 dark:bg-gray-800 overflow-hidden">
//                     <img
//                       src={img}
//                       alt={c.code}
//                       className="h-full w-full object-cover group-hover:scale-[1.02] transition-transform duration-300"
//                     />
//                   </div>
//                   {/* status chip */}
//                   <div className="absolute left-3 top-3">
//                     <span
//                       className={cn(
//                         "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold shadow",
//                         c.isActive ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"
//                       )}
//                     >
//                       <span className="h-1.5 w-1.5 rounded-full bg-current" />
//                       {c.isActive ? "Active" : "Inactive"}
//                     </span>
//                   </div>
//                 </div>

//                 {/* body */}
//                 <div className="p-4 flex-1 flex flex-col">
//                   <div className="flex items-start justify-between gap-3">
//                     <div className="min-w-0">
//                       <h3 className="font-semibold text-slate-900 dark:text-white truncate">{c.code}</h3>
//                       {c.description && (
//                         <p className="mt-1 text-sm text-slate-600 dark:text-slate-400 line-clamp-2">
//                           {c.description}
//                         </p>
//                       )}
//                     </div>

//                     {/* toggle */}
//                     <label className="inline-flex items-center cursor-pointer select-none">
//                       <input
//                         type="checkbox"
//                         className="sr-only peer"
//                         checked={!!c.isActive}
//                         onChange={() => askToggle(c)}
//                         disabled={isBusy}
//                       />
//                       <span
//                         className={cn(
//                           "w-10 h-6 rounded-full relative transition-colors",
//                           "peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-amber-300",
//                           c.isActive ? "bg-emerald-500/80" : "bg-slate-300"
//                         )}
//                       >
//                         <span
//                           className={cn(
//                             "absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform",
//                             c.isActive ? "translate-x-4" : "translate-x-0"
//                           )}
//                         />
//                       </span>
//                     </label>
//                   </div>

//                   {/* facts */}
//                   <div className="mt-3 grid grid-cols-1 gap-y-1 text-sm text-slate-700 dark:text-slate-300">
//                     <Row label="Discount" value={<>{discountLabel(c)} <span className="text-slate-500">({c.discountType})</span></>} />
//                     <Row label="Validity" value={validity} />
//                     <Row label="Usage" value={usage} />
//                     <Row label="Min Purchase" value={INR(c.minPurchaseAmount)} />
//                     <Row label="Applicable" value={appliesTo} />
//                   </div>

//                   {/* actions */}
//                   <div className="mt-4 flex items-center justify-end gap-2">
//                     <button
//                       onClick={() => onEdit(c)}
//                       className="rounded-full border px-3 py-1.5 text-xs font-semibold hover:bg-amber-50 dark:hover:bg-gray-800"
//                       disabled={isBusy}
//                     >
//                       ✏️ Edit
//                     </button>
//                     <button
//                       onClick={() => askDelete(c)}
//                       className="rounded-full border border-rose-300 px-3 py-1.5 text-xs font-semibold text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/20"
//                       disabled={isBusy}
//                     >
//                       🗑 Delete
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}

//         {!fetching && isEmpty && (
//           <div className="col-span-full">
//             <div className="rounded-2xl border bg-white dark:bg-gray-900 dark:border-gray-800 p-10 text-center">
//               <div className="text-5xl mb-2">🎟️</div>
//               <div className="text-sm text-slate-600 dark:text-slate-400">
//                 No coupons found. Adjust filters or create a new coupon.
//               </div>
//               <button
//                 onClick={onNew}
//                 className="mt-4 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 px-5 py-2 text-sm font-semibold text-slate-900 hover:from-amber-500 hover:to-amber-600"
//               >
//                 Create Coupon
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Confirm Modal */}
//       {confirm.open && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//           <div className="absolute inset-0 bg-black/50" onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" })} />
//           <div className="relative w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 border dark:border-gray-800 shadow-xl p-6 animate-[fadeIn_.18s_ease]">
//             <h3 className="text-lg font-bold text-slate-900 dark:text-white">
//               {confirm.mode === "delete" ? "Delete Coupon" : "Confirm Status Change"}
//             </h3>
//             <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
//               {confirm.mode === "delete" ? (
//                 <>Are you sure you want to permanently delete <b>{confirm.name}</b>?</>
//               ) : (
//                 <>Set <b>{confirm.name}</b> to <b>{confirm.nextActive ? "Active" : "Inactive"}</b>?</>
//               )}
//             </p>

//             <div className="mt-6 grid grid-cols-2 gap-2">
//               {confirm.mode === "delete" ? (
//                 <>
//                   <button
//                     onClick={doDelete}
//                     className="rounded-full bg-rose-600 text-white px-4 py-2 text-sm font-semibold hover:bg-rose-700"
//                   >
//                     Delete
//                   </button>
//                   <button
//                     onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" })}
//                     className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-gray-800"
//                   >
//                     Cancel
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <button
//                     onClick={doToggle}
//                     className="rounded-full bg-amber-500 text-white px-4 py-2 text-sm font-semibold hover:bg-amber-600"
//                   >
//                     Confirm
//                   </button>
//                   <button
//                     onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" })}
//                     className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-gray-800"
//                   >
//                     Cancel
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* tiny bits */
// function Select({ label, value, onChange, options }) {
//   return (
//     <label className="block">
//       <div className="text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1">{label}</div>
//       <div className="relative">
//         <select
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           className="w-full appearance-none rounded-xl border px-3 py-2 bg-white dark:bg-gray-950 dark:border-gray-800 text-sm pr-8"
//         >
//           {options.map((o) => (
//             <option key={o.value} value={o.value}>{o.label}</option>
//           ))}
//         </select>
//         <svg
//           className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-slate-400"
//           width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
//           strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
//         >
//           <path d="M6 9l6 6 6-6" />
//         </svg>
//       </div>
//     </label>
//   );
// }

// function Row({ label, value }) {
//   return (
//     <div className="flex items-start gap-2 text-sm">
//       <div className="min-w-[110px] text-slate-500 dark:text-slate-400">{label}:</div>
//       <div className="font-medium text-slate-900 dark:text-white">{value}</div>
//     </div>
//   );
// }

// src/pages/admin/coupons/AdminCuppon.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../../config/api";
import { get, del, put } from "../../../lib/http";
import { AD } from "../../adminUi.js";
import { formatDateIST } from "../../../utils/datetime.js";

const cn = (...a) => a.filter(Boolean).join(" ");
const INR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export default function AdminCuppon() {
  const navigate = useNavigate();

  // data
  const [coupons, setCoupons] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  // filters
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all"); // all | active | inactive
  const [type, setType] = useState("all"); // percentage | flat | bogo | all
  const [sort, setSort] = useState("latest"); // latest | oldest | az | za | valueHigh | valueLow

  // pagination (controlled state)
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // confirm modal
  const [confirm, setConfirm] = useState({
    open: false,
    id: null,
    name: "",
    nextActive: false,
    mode: "toggle",
  });

  /* ================== fetcher (deterministic) ================== */
  // Always call fetchCoupons with explicit page & limit to avoid races.
  const fetchCoupons = async ({ page: p = 1, limit: l = limit, q: qq = q, status: st = status, type: tp = type, sort: srt = sort } = {}) => {
    setFetching(true);
    setError("");
    try {
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const params = new URLSearchParams();
      if (qq?.trim()) params.append("q", qq.trim());
      if (st && st !== "all") params.append("status", st);
      if (tp && tp !== "all") params.append("type", tp);
      if (srt) params.append("sort", srt);
      params.append("page", String(p));
      params.append("limit", String(l));

      const url = `${API.coupon.listCoupons}?${params.toString()}`;
      const res = await get(url, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
        },
      });

      // expected shape: { data: [...], total, page, limit, totalPages }
      console.log("fetchCoupons res:", res);
      const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      const totalCount = Number(res?.total ?? res?.totalDocs ?? 0) || list.length;
      const gotPage = Number(res?.page ?? p) || p;
      const gotLimit = Number(res?.limit ?? l) || l;
      const gotTotalPages = Number(res?.totalPages ?? Math.max(1, Math.ceil(totalCount / (gotLimit || 1)))) || Math.max(1, Math.ceil(totalCount / (gotLimit || 1)));

      // set states deterministically from server response (or sensible fallbacks)
      setCoupons(list);
      setTotal(totalCount);
      setPage(Math.min(Math.max(1, gotPage), gotTotalPages));
      setLimit(gotLimit);
      setTotalPages(Math.max(1, gotTotalPages));
    } catch (err) {
      console.error("fetchCoupons err:", err);
      setCoupons([]);
      setTotal(0);
      setPage(1);
      setTotalPages(1);
      setError("Failed to load coupons.");
    } finally {
      setFetching(false);
    }
  };

  // initial load
  useEffect(() => {
    fetchCoupons({ page: 1, limit });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // When filters change, we immediately fetch page 1 with new filters
  useEffect(() => {
    // reset to page 1 when any filter/sort changes
    setPage(1);
    fetchCoupons({ page: 1, limit, q, status, type, sort });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, status, type, sort]);

  // When page changes (via gotoPage), fetch using current filters
  useEffect(() => {
    fetchCoupons({ page, limit, q, status, type, sort });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  /* ================== helpers ================== */
  const fmtDate = (iso) => formatDateIST(iso);

  const discountLabel = (c) =>
    String(c?.discountType).toLowerCase() === "percentage"
      ? `${Number(c?.value ?? 0)}% off`
      : `${INR(c?.value ?? 0)} off`;

  const typeOptions = useMemo(() => {
    const s = new Set();
    coupons.forEach((c) => c?.discountType && s.add(String(c.discountType).toLowerCase()));
    ["percentage", "flat", "bogo"].forEach((t) => s.add(t));
    return ["all", ...Array.from(s).sort()];
  }, [coupons]);

  const isEmpty = !fetching && coupons.length === 0;

  /* ================== actions ================== */
  const onNew = () => navigate("/admin/coupon/new");
  const onEdit = (c) => navigate(`/admin/coupon/edit/${c._id}`);

  const askDelete = (c) =>
    setConfirm({
      open: true,
      id: c._id,
      name: c.code,
      nextActive: !!c.isActive,
      mode: "delete",
    });

  const askToggle = (c) =>
    setConfirm({
      open: true,
      id: c._id,
      name: c.code,
      nextActive: !c.isActive,
      mode: "toggle",
    });

  const doDelete = async () => {
    if (!confirm.id) return;
    try {
      setBusyId(confirm.id);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      await del(`${API.coupon.delete}/${confirm.id}`, {
        headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
      });
      // refetch current page after deletion to get updated totals from server
      // if deleting caused current page to become empty, server will send appropriate page
      fetchCoupons({ page, limit, q, status, type, sort });
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete coupon.");
    } finally {
      setBusyId(null);
      setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" });
    }
  };

  const doToggle = async () => {
    if (!confirm.id) return;
    try {
      setBusyId(confirm.id);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      await put(`${API.coupon.update}/${confirm.id}`, { isActive: confirm.nextActive }, { headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" } });
      // optimistic local update then refetch page
      fetchCoupons({ page, limit, q, status, type, sort });
    } catch (err) {
      console.error("Toggle error:", err);
      alert("Failed to update status.");
    } finally {
      setBusyId(null);
      setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" });
    }
  };

  /* ================== pagination helpers ================== */
  const gotoPage = (p) => {
    let np = Number(p) || 1;
    if (np < 1) np = 1;
    if (np > totalPages) np = totalPages;
    setPage(np);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const pageNumbers = useMemo(() => {
    const tp = Number(totalPages) || 1;
    const cur = Math.min(Math.max(1, Number(page) || 1), tp);
    const maxButtons = 7;
    let start = Math.max(1, cur - Math.floor(maxButtons / 2));
    let end = Math.min(tp, start + maxButtons - 1);
    if (end - start < maxButtons - 1) start = Math.max(1, end - maxButtons + 1);
    const arr = [];
    for (let i = start; i <= end; i++) arr.push(i);
    return arr;
  }, [totalPages, page]);

  /* ================== UI ================== */
  return (
    <div className={AD.page}>
      {/* Title & actions */}
      <div className={AD.headerRow}>
        <div>
          <h1 className={AD.title}>Discount coupons</h1>
          <p className={AD.subtitle}>Create, edit, and manage promo codes</p>
        </div>
        <div className={AD.toolbar}>
          <button type="button" onClick={() => fetchCoupons({ page: 1, limit, q, status, type, sort })} className={AD.btnSecondary}>
            Refresh
          </button>
          <button type="button" onClick={onNew} className={AD.btnPrimary}>
            New coupon
          </button>
        </div>
      </div>

      {/* error */}
      {error && <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">{error}</div>}

      {/* toolbar */}
      <div className={cn("sticky top-2 z-10", AD.filterCard)}>
        <div className="grid gap-3 md:grid-cols-5">
          <div className="md:col-span-2">
            <label className="block text-xs font-semibold text-slate-600 dark:text-slate-300">Search</label>
            <div className="relative mt-1">
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by code or description…" className={AD.input} />
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-3.5-3.5"/></svg>
            </div>
          </div>

          <Select label="Type" value={type} onChange={(v) => { setType(v); }} options={typeOptions.map((t) => ({ label: t === "all" ? "All" : t, value: t }))} />

          <Select label="Status" value={status} onChange={(v) => { setStatus(v); }} options={[{ label: "All", value: "all" }, { label: "Active", value: "active" }, { label: "Inactive", value: "inactive" }]} />

          <Select label="Sort" value={sort} onChange={(v) => { setSort(v); }} options={[{ label: "Latest", value: "latest" }, { label: "Oldest", value: "oldest" }, { label: "A → Z", value: "az" }, { label: "Z → A", value: "za" }, { label: "Value (High)", value: "valueHigh" }, { label: "Value (Low)", value: "valueLow" }]} />
        </div>
      </div>

      {/* list (table) */}
      <div className={AD.tableShell}>
        <div className="max-w-full overflow-x-auto">
          <table className="w-full min-w-[640px] table-fixed border-collapse text-sm">
            <thead className={AD.thead}>
              <tr>
                <th className="w-14 px-2 py-3 text-left font-bold" scope="col">
                  <span className="sr-only">Image</span>
                </th>
                <th className="w-[11%] px-2 py-3 text-left font-bold" scope="col">
                  Code
                </th>
                <th className="w-[22%] px-2 py-3 text-left font-bold" scope="col">
                  Description
                </th>
                <th className="w-[12%] px-2 py-3 text-left font-bold" scope="col">
                  Discount
                </th>
                <th className="w-[16%] px-2 py-3 text-left font-bold" scope="col">
                  Validity
                </th>
                <th className="w-[8%] px-2 py-3 text-left font-bold" scope="col">
                  Usage
                </th>
                <th className="w-[10%] px-2 py-3 text-left font-bold" scope="col">
                  Scope
                </th>
                <th className="w-[9%] px-2 py-3 text-left font-bold" scope="col">
                  Status
                </th>
                <th className="w-[7%] px-2 py-3 text-center font-bold" scope="col">
                  On
                </th>
                <th className="w-[12%] px-2 py-3 text-right font-bold" scope="col">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-gray-800">
              {fetching &&
                Array.from({ length: 8 }).map((_, i) => (
                  <tr key={`sk-${i}`} className="animate-pulse">
                    {Array.from({ length: 10 }).map((__, j) => (
                      <td key={j} className="px-2 py-3">
                        <div className="h-4 w-full rounded bg-slate-200 dark:bg-gray-800" />
                      </td>
                    ))}
                  </tr>
                ))}

              {!fetching &&
                !isEmpty &&
                coupons.map((c) => {
                  const img = c.imageUrl || "https://picsum.photos/seed/coupon/800/400";
                  const validity = `${fmtDate(c.validFrom)} → ${fmtDate(c.validTo)}`;
                  const appliesTo =
                    Array.isArray(c.applicableEvents) && c.applicableEvents.length > 0
                      ? `${c.applicableEvents.length} event(s)`
                      : "All events";
                  const usage =
                    c.usageLimit && c.usageLimit > 0 ? `${c.usedCount ?? 0}/${c.usageLimit}` : `${c.usedCount ?? 0}/∞`;
                  const isBusy = busyId === c._id;

                  return (
                    <tr key={c._id} className="align-middle transition-colors hover:bg-amber-50/50 dark:hover:bg-amber-950/10">
                      <td className="px-2 py-2.5">
                        <div className="h-10 w-14 overflow-hidden rounded-lg border border-slate-200 bg-slate-100 dark:border-gray-700 dark:bg-gray-800">
                          <img src={img} alt="" className="h-full w-full object-cover" loading="lazy" />
                        </div>
                      </td>
                      <td className="min-w-0 px-2 py-2.5">
                        <span className="font-semibold text-slate-900 dark:text-white">{c.code}</span>
                        <div className="mt-0.5 text-[11px] text-slate-500 dark:text-slate-400">Min {INR(c.minPurchaseAmount)}</div>
                      </td>
                      <td className="min-w-0 px-2 py-2.5">
                        <p className="line-clamp-2 text-slate-600 dark:text-slate-300">{c.description || "—"}</p>
                      </td>
                      <td className="min-w-0 px-2 py-2.5 text-slate-700 dark:text-slate-200">
                        <span className="font-medium">{discountLabel(c)}</span>
                        <span className="mt-0.5 block text-[11px] capitalize text-slate-500">{c.discountType || "—"}</span>
                      </td>
                      <td className="min-w-0 px-2 py-2.5 text-xs leading-snug text-slate-600 dark:text-slate-400">{validity}</td>
                      <td className="min-w-0 px-2 py-2.5 tabular-nums text-slate-700 dark:text-slate-200">{usage}</td>
                      <td className="min-w-0 px-2 py-2.5 text-xs text-slate-600 dark:text-slate-400">{appliesTo}</td>
                      <td className="px-2 py-2.5">
                        <span
                          className={cn(
                            "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold",
                            c.isActive ? "bg-emerald-100 text-emerald-700" : "bg-rose-100 text-rose-700"
                          )}
                        >
                          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current" aria-hidden />
                          {c.isActive ? "Active" : "Off"}
                        </span>
                      </td>
                      <td className="px-2 py-2.5 text-center">
                        <label className="inline-flex cursor-pointer select-none items-center justify-center">
                          <input
                            type="checkbox"
                            className="peer sr-only"
                            checked={!!c.isActive}
                            onChange={() => askToggle(c)}
                            disabled={isBusy}
                          />
                          <span
                            className={cn(
                              "relative h-6 w-10 rounded-full transition-colors",
                              "peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-amber-400",
                              c.isActive ? "bg-emerald-500/85" : "bg-slate-300 dark:bg-slate-600"
                            )}
                          >
                            <span
                              className={cn(
                                "absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform",
                                c.isActive ? "translate-x-4" : "translate-x-0"
                              )}
                            />
                          </span>
                        </label>
                      </td>
                      <td className="px-2 py-2.5 text-right">
                        <div className="flex flex-wrap items-center justify-end gap-1">
                          <button type="button" onClick={() => onEdit(c)} className={`${AD.btnSecondary} py-1.5 text-xs`} disabled={isBusy}>
                            Edit
                          </button>
                          <button type="button" onClick={() => askDelete(c)} className={`${AD.btnDanger} py-1.5 text-xs`} disabled={isBusy}>
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}

              {!fetching && isEmpty && (
                <tr>
                  <td colSpan={10} className="p-0">
                    <div className={AD.emptyState}>
                      <p className="text-sm font-medium text-slate-700 dark:text-slate-300">No coupons match your filters</p>
                      <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">Adjust search or create a new coupon.</p>
                      <button type="button" onClick={onNew} className={`${AD.btnPrimary} mt-5`}>
                        Create coupon
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* pagination */}
      <div className="flex items-center justify-between gap-4">
        <div className="text-sm text-slate-600 dark:text-slate-400">Showing page <b>{page}</b> of <b>{totalPages}</b> • <span>{total}</span> total</div>

        <div className="flex items-center gap-2">
          <label className="flex items-center gap-2 text-sm">
            <span className="text-slate-600 dark:text-slate-300">Per page</span>
            <select value={limit} onChange={(e) => {
              const newLimit = Number(e.target.value) || 12;
              setLimit(newLimit);
              // fetch immediately for new page size, reset to page 1
              setPage(1);
              fetchCoupons({ page: 1, limit: newLimit, q, status, type, sort });
            }} className={`${AD.select} !w-auto min-w-[4.5rem] py-1.5 text-sm`}>
              {[6, 12, 24, 48].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </label>

          <div className="flex flex-wrap items-center gap-1">
            <button type="button" onClick={() => gotoPage(page - 1)} disabled={page <= 1} className={cn(AD.btnSecondary, "py-1.5 text-sm", page <= 1 && "opacity-50")}>Prev</button>
            {pageNumbers.map((p) => (
              <button
                type="button"
                key={p}
                onClick={() => gotoPage(p)}
                className={cn(
                  "min-w-[2.25rem] rounded-lg px-2 py-1.5 text-sm font-semibold transition",
                  p === page ? "bg-amber-400 text-slate-900 shadow-sm" : `${AD.btnGhost} border border-slate-200 py-1.5 dark:border-gray-700`
                )}
              >
                {p}
              </button>
            ))}
            <button type="button" onClick={() => gotoPage(page + 1)} disabled={page >= totalPages} className={cn(AD.btnSecondary, "py-1.5 text-sm", page >= totalPages && "opacity-50")}>Next</button>
          </div>
        </div>
      </div>

      {/* confirm modal */}
      {confirm.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50" onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" })} />
          <div className="relative w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 border dark:border-gray-800 shadow-xl p-6">
            <h3 className="text-lg font-bold text-slate-900 dark:text-white">{confirm.mode === "delete" ? "Delete Coupon" : "Confirm Status Change"}</h3>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{confirm.mode === "delete" ? <>Are you sure you want to permanently delete <b>{confirm.name}</b>?</> : <>Set <b>{confirm.name}</b> to <b>{confirm.nextActive ? "Active" : "Inactive"}</b>?</>}</p>
            <div className="mt-6 grid grid-cols-2 gap-2">
              {confirm.mode === "delete" ? (
                <>
                  <button onClick={doDelete} className="rounded-full bg-rose-600 text-white px-4 py-2 text-sm font-semibold hover:bg-rose-700">Delete</button>
                  <button onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" })} className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-gray-800">Cancel</button>
                </>
              ) : (
                <>
                  <button onClick={doToggle} className="rounded-full bg-amber-500 text-white px-4 py-2 text-sm font-semibold hover:bg-amber-600">Confirm</button>
                  <button onClick={() => setConfirm({ open: false, id: null, name: "", nextActive: false, mode: "toggle" })} className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-gray-800">Cancel</button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* small helpers */
function Select({ label, value, onChange, options }) {
  return (
    <label className="block">
      <div className="text-xs font-semibold text-slate-600 dark:text-slate-300 mb-1">{label}</div>
      <div className="relative">
        <select value={value} onChange={(e) => onChange(e.target.value)} className={AD.select}>
          {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-slate-400" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
      </div>
    </label>
  );
}
